module.exports = __webpack_public_path__ + "static/media/vision.dc910de3.png";